module.exports = __webpack_public_path__ + "media/images/pages/sample_images/sample-culture-64227c411bdefbffbd2dd806dd9f08f7.jpeg";